import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { BILLING_ENABLED, BILLING_DISABLED_REDIRECT } from '@core/config/billing.config';

/**
 * Cierra las rutas de facturación cuando está apagada (ver `billing.config`).
 *
 * Hace falta un guard y no basta con ocultar los items del menú: las cuatro
 * rutas de facturación no tenían NINGÚN `canActivate`, así que cualquiera que
 * tecleara /dashboard/payments-invoices entraba igual. Ocultar el botón no
 * cierra la puerta.
 */
export const billingEnabledGuard: CanActivateFn = () => {
  if (BILLING_ENABLED) {
    return true;
  }

  inject(Router).navigate([BILLING_DISABLED_REDIRECT]);

  return false;
};
